import {Pill} from "../../../entities/pill";
import pillRepository from "../../../../infrastructure/repository/impl/pill/pill_repository";
import PillUseCasesInterface from "./pillInterface";

class PillUseCases implements PillUseCasesInterface {
  async list(): Promise<Pill[]> {
    return await pillRepository.list();
  }

  async get(id: number): Promise<Pill> {
    return await pillRepository.get(id);
  }

  async watch(id: number): Promise<void> {
    await pillRepository.watch(id);
  }
}

export default new PillUseCases() as PillUseCasesInterface;
